import e from "../../../utilities/tw.js";
const t = {
  base: e`flex size-[22px] shrink-0 appearance-none items-center justify-center rounded border-2 data-[state=checked]:bg-primary data-[state=checked]:hover:border-primary-hover data-[state=checked]:hover:bg-primary-hover data-[state=checked]:hover:transition data-[state=unchecked]:hover:transition data-[state=checked]:hover:duration-300 data-[state=unchecked]:hover:duration-300 data-[state=checked]:disabled:border-disabled-surface data-[state=unchecked]:disabled:border-disabled data-[state=checked]:disabled:bg-disabled-surface data-[state=unchecked]:disabled:bg-disabled-surface`,
  indicator: e`flex size-[22px] items-center justify-center rounded text-surface checked:bg-warning `,
  label: e`ms-2 flex items-center text-caption-md text-neutral-inverse`,
  variant: {
    primary: e`border-primary hover:bg-secondary-hover focus-visible:rounded focus-visible:outline-none focus-visible:outline-offset-2 focus-visible:outline-primary disabled:cursor-not-allowed`
  }
};
export {
  t as checkboxStyles
};
